import BillingAiCreditsUsageComponent from 'webapp/components/billing/ai-credits/usage';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPopupAiCreditsUsageComponent extends PopupInnerModalComponent {
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Ai" @size="lg" />
			AI credit usage by account
		</div>
		<div class="content">
			<BillingAiCreditsUsageComponent @onContentChange={{this.scheduleReposition}} />
		</div>
	</template>
}
